import { PayloadAction } from '../../../store.model';
import { makeRows } from '../focus-selection/focus-selection.function';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';

import { FocusSelectorFilterFocuses } from './focus-selection-filter.action';

export function focusSelectorFilterFocusesReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorFilterFocuses>,
): FocusSelectorState {
    const { behaviourId } = action.payload;

    const filteredRows = makeRows(
        state.behaviours,
        state.activeMetric.id,
        state.focusSelectionGrid.selection?.subBehaviourId,
        behaviourId,
    );

    return {
        ...state,
        focusSelectionGrid: {
            ...state.focusSelectionGrid,
            rows: filteredRows,
            sortDefs: [...state.focusSelectionGrid.sortDefs],
            filterByBehaviourId: behaviourId,
        },
    };
}
